import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { RatingsWidgetComponent } from "../ratings-widget/ratings-widget.component";
import { AdminToolsComponent } from "./admin-tools/admin-tools.component";
import { PageHeaderComponent } from '../page-header/page-header.component';

@Component({
  selector: 'app-admin-panel',
  standalone: true,
  templateUrl: './admin-panel.component.html',
  styleUrls: ['./admin-panel.component.css'],
  imports: [CommonModule,
    RouterModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    AdminToolsComponent,
    PageHeaderComponent,
  ],
})
export class AdminPanelComponent {}
